/**
 * Слой поверх экрана, который закрывается кнопкой «Назад»
 * (docs/08-mobile-roadmap.md, M1).
 *
 * На телефоне «Назад» — системный жест, и человек ждёт, что он закроет
 * открытый поиск или лист, а не уведёт с доски. Поэтому открытие слоя —
 * это запись в истории с тем же адресом и пометкой в state, а закрытие —
 * шаг назад. Адрес не меняется: ссылку на открытый поиск не отправить,
 * и не нужно.
 *
 * Переход из слоя (выбор результата) делается с replace: запись слоя
 * заменяется новым адресом, и «Назад» с результата ведёт туда, где слой
 * открывали, а не обратно в слой.
 */

import { useLocation, useNavigate } from "react-router-dom";

interface OverlayState {
  overlay?: string;
}

export function useHistoryOverlay(key: string): {
  open: boolean;
  show: () => void;
  hide: () => void;
} {
  const location = useLocation();
  const navigate = useNavigate();
  const state = (location.state ?? null) as OverlayState | null;
  const open = state?.overlay === key;

  return {
    open,
    show: () => {
      if (open) return;
      void navigate(`${location.pathname}${location.search}${location.hash}`, {
        state: { ...state, overlay: key },
      });
    },
    hide: () => {
      if (!open) return;
      // Первая запись истории (key «default»): шагать назад некуда — шаг
      // увёл бы с сайта. Так бывает, если state пришёл не от show().
      if (location.key === "default") {
        void navigate(`${location.pathname}${location.search}${location.hash}`, {
          replace: true,
          state: { ...state, overlay: undefined },
        });
        return;
      }
      void navigate(-1);
    },
  };
}
